<template>    
        <v-container class="">
            <v-row class="">
               <html>
	<head>
		<meta content="text/html; charset=UTF-8" http-equiv="content-type">
			
		</head>
		<body class="c2 px-4">
			<p class="c0">
				<span class="c4">TERMS AND POLICIES: - PATIENTS SECTION</span>
			</p>
			<p class="c0">
				<span class="c1">Terms of Use</span>
			</p>
			<p class="c0">
				<span class="c1">Welcome to the portal www.HealthyAlways.com, (the &quot;Website&quot;). The Website is operated by Zasnova Healthcare Private Limited, India, and authorized/licensed Zasnova Healthcare Private Limited.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">The terms &#39;You&#39; or &#39;Your&#39; refer to You as the user (irrespective of whether You are a Registered User or a Non-Registered User or an Healthcare Practitioner (HCP)) and the terms &#39;HealthyAlways&#39; ,&#39;We&#39;, &#39;Us&#39;, &#39;Company&#39;, and &#39;Our&#39; refer to Zasnova Healthcare, INDIA and / or Zasnova Healthcare Private Limited.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">PLEASE CAREFULLY READ THE FOLLOWING TERMS OF USE OF THE WEBSITE. THESE TERMS OF USE TOGETHER WITH THE PRIVACY POLICY ARE AVAILABLE AT www.HealthyAlways.com/privacy, ADDITIONAL TERMS OF USE FOR HCPS https://doctor.HealthyAlways.com/terms AND OTHER POLICIES WHICH MAY BE APPLICABLE TO SPECIFIC PORTIONS OF THIS WEBSITE CONSTITUTE THE TERMS OF YOUR ACCESS TO AND USAGE OF THE WEBSITE. BY CLICKING ON THE &#39;I ACCEPT&#39; BUTTON AT THE END OF THIS PAGE OR ACCESSING OR USING THIS WEBSITE, YOU AGREE TO BE BOUND BY THESE TERMS OF USE, THE PRIVACY POLICY, THE ADDITIONAL TERMS OF USE FOR HCPS AND OTHER POLICIES WHICH MAY BE APPLICABLE TO THIS WEBSITE. IF YOU DO NOT AGREE TO BE BOUND BY THESE TERMS OF USE, THE PRIVACY POLICY, THE ADDITIONAL TERMS OF USE FOR HCPS AND OTHER POLICIES WHICH MAY BE APPLICABLE TO SPECIFIC PORTIONS OF THIS WEBSITE PLEASE DO NOT ACCESS OR USE THE WEBSITE.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">These Terms of Use, the Privacy Policy, the Additional Terms of Use for HCPs, together with any other policies which may be applicable to specific portions of Website and any disclaimers which may be present on the Website are referred to as &quot;Agreement&quot;.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">If you are accessing the HealthyAlways mobile application, then this Agreement will continue to apply to such use. In addition, there may be additional terms (such as the terms imposed by mobile application stores) which will govern the use of the mobile application. In such case, the term &#39;Website&#39; will be deemed to refer to the HealthyAlways mobile application.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">The features / services of this Website are available only in India. However Non-Registered Users outside India may browse through the information provided in the Website</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">The Agreement supersedes all previous oral and written terms and conditions (if any) communicated to you.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">1. THE WEBSITE</span>
			</p>
			<p class="c0">
				<span class="c1">1.1. Users: The Website is accessible to visitors / non-registered users, registered users and healthcare practitioners. &quot;Registered Users&quot; are users who have registered themselves an account on the Website by providing HealthyAlways with certain information and who can log on to the Website by providing their username and password. &quot;Non-Registered Users&quot; are users who are not registered with the Website but may access information on the Website. Certain features of the Website are available to Registered Users only. &quot;Health Care Practitioners&quot; or &quot;HCPs&quot; are duly qualified members of medical or dental profession and (a) with whom Registered Users can book appointment using the Website or (b) who can provide information to questions raised by Registered Users or (c) with whom Registered Users can consult privately with respect to their queries or d) who can generate and provide health related information and education material for general use of Registered Users. &ldquo;Labs&quot; are registered laboratories that collect patient samples from Registered Users for the purpose of conducting pathological tests and varied diagnostic services referred to as &quot;Lab Tests&quot;. Registered Users, Non-Registered Users and HCPs shall collectively be referred to as &quot;Users&quot;.</span>
			</p>
			<p class="c0">
				<span class="c1">1.2. Features of the Website: The Website offers the following features:</span>
			</p>
			<p class="c0">
				<span class="c1">a) For Registered Users:</span>
			</p>
			<p class="c0">
				<span class="c1">i. Platform for obtaining generic and preliminary information from HCP to a health related question: You may ask any health related question on the Website and obtain preliminary and generic information to such question from a HCP. Your identity is not disclosed to the HCPs or other Registered Users at this stage.</span>
			</p>
			<p class="c0">
				<span class="c1">ii. Platform for viewing generic and preliminary information of HCP on questions submitted by other Registered Users: You may access the information provided by an HCP to questions submitted by other Registered Users on the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">iii. Platform to schedule in-person appointment with HCP: You may use Website to schedule an in-person appointment with HCP at the HCP&#39;s premises.</span>
			</p>
			<p class="c0">
				<span class="c1">iv. Platform to interact with HCP privately: You may interact with an HCP privately on the chat feature available on the Website or via other communication feature which the Website may provide after paying consultation fee to the HCP and an internet handling fee to HealthyAlways as applicable from time to time but not exceeding 50% of HCP consultation fees.</span>
			</p>
			<p class="c0">
				<span class="c1">v. Platform to pay HCP for non-Website interaction: You may make use of the Website solely for the purpose of paying an HCP for a non-Website/offline interaction with such HCP after paying HealthyAlways internet handling fee.</span>
			</p>
			<p class="c0">
				<span class="c1">vi. Platform to order Lab Tests from Labs: You may use the Website to order Lab Tests from Labs. The Website allows you to schedule a sample pick-up at Your home, which will be used by a Lab to conduct a Lab Test and share the results of such Lab Test with You through the Website. Visit www.HealthyAlways.com/lab-tests to learn more about the Lab Tests that are offered on the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">b) For Non-Registered Users:</span>
			</p>
			<p class="c0">
				<span class="c1">i. Access to HCP Profiles: Depending on the extent of information shared by HCPs at the time of registering with the Website, the HCPs&#39; profile containing their name, qualification, experience, specialization, consultant fees, personal statement, education, professional memberships etc. can be accessed by You. The Website offers various search features to aid you in accessing HCP profiles.</span>
			</p>
			<p class="c0">
				<span class="c1">ii. Access to HCP Availability for in-person appointment: Based on information communicated by HCP, the Website shows indicative appointment slots available for in-person consultation at HCP&#39;s premises.</span>
			</p>
			<p class="c0">
				<span class="c1">c) For HCPs:</span>
			</p>
			<p class="c0">
				<span class="c1">i. Platform to publish profile: You may upload your profile containing your name, qualification, experience, specialization, consultation fees, personal statement, education, professional memberships etc. on Website. Your profile is accessible to all Registered as well as Non-Registered Users.</span>
			</p>
			<p class="c0">
				<span class="c1">ii. Platform for private interaction: You may use Website for private interaction with Registered Users. In course of the private interaction, you can exchange texts, images; videos over the chat feature of the platform and communicate through other means provided by the HealthyAlways such as calls.</span>
			</p>
			<p class="c0">
				<span class="c1">iii. Platform to receive consultation fees for non-Website interaction: You may use the Website to receive fees for your interactions with Registered User outside the Website / offline.</span>
			</p>
			<p class="c0">
				<span class="c1">iv. Platform to provide information to questions to health related questions submitted by Registered Users: You may provide your preliminary and generic information to health related questions submitted by Registered Users.</span>
			</p>
			<p class="c0">
				<span class="c1">v. Platform to publish HCP-contributed health related information and education material: You may contribute health related information and education material which HealthyAlways may, with or without modification, in its sole discretion, publish on the Website.</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
			<p class="c0">
				<span class="c1">1.3. Types of content on the Website:</span>
			</p>
			<p class="c0">
				<span class="c1">The various types of content available on the Website may be categorised as follows:</span>
			</p>
			<p class="c0">
				<span class="c1">1.3.1. Content provided by Registered Users including questions provided by Registered Users and interactions in the course of private interactions with HCPs (&quot;User Content&quot;)</span>
			</p>
			<p class="c0">
				<span class="c1">1.3.2. Content provided by HCP including health related information and educational material; and information provided by way of responses to questions rose by Registered Users or in course of private interactions with Registered Users (&quot;HCP Content&quot;);</span>
			</p>
			<p class="c0">
				<span class="c1">1.3.3 Content provided by Labs including instructions, results, reports and any other information relating to Lab Tests (&quot;Lab Content&quot;).</span>
			</p>
			<p class="c0">
				<span class="c1">1.3.4. Content which HealthyAlways (through itself or its contractors) has generated or procured for the Website (&quot;HealthyAlways Content&quot;);</span>
			</p>
			<p class="c0">
				<span class="c1">2. USE OF THE SITE</span>
			</p>
			<p class="c0">
				<span class="c1">2.1. Use by all Users (Registered, Non-Registered User and HCP)</span>
			</p>
			<p class="c0">
				<span class="c1">2.1.1. You will use the Website and the features provided by the Website only in relation to and in compliance with all applicable Indian laws. You will not use this Website or any feature provided by the Website for any purposes not intended under this Agreement.</span>
			</p>
			<p class="c0">
				<span class="c1">2.1.2. You will not deliberately use the Website in any way that is unlawful or harms HealthyAlways, its directors, employees, affiliates, distributors, partners, service providers and/or any User and/or data or content on the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">2.1.3. You understand that as part of your registration process as well as in course of your use of the Website, You may receive SMS messages from HealthyAlways on Your registered mobile number. These messages will relate to your registration, transactions that you carry out through the Website and any such information found suitable of your attention by HealthyAlways. Please note that HealthyAlways will send these SMS messages only to the mobile number that you provide on the Website. It is your responsibility to ensure that you provide the correct number for the transaction you wish to enter into. Further, HealthyAlways may also send notifications and reminders to you with respect to appointments scheduled by you for the features that you may be using on the Website. You hereby consent to receive such messages from HealthyAlways.</span>
			</p>
			<p class="c0">
				<span class="c1">2.1.4. By using the website and/or registering Yourself at HealthyAlways You authorize us to contact You via email or phone call or SMS and offer You services for the product You have opted for, imparting product knowledge, offer promotional offers running on website, for which reasons, personally identifiable information may be collected as detailed below. And Irrespective of the fact if also you have registered yourself under DND or DNC or NCPR service, you still authorize us to give you a call from the HealthyAlways &amp; associate partners for the above mentioned purposes till 45 days of your engagement with us.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2. Use by Registered User</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.1. You acknowledge that this Website is an informative platform only. HealthyAlways and this Website are not in the business of providing healthcare service or hospital services.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.2. We encourage you to independently verify any information you see on the Website including information provided by a HCP. You will use the Website and the features provided by the Website only in relation to and in compliance with all applicable Indian laws. You will not use this Website or any feature provided by the Website for any purposes not intended under this Agreement.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.3. The Website allows you to select and schedule appointments with HCPS. In doing so, HealthyAlways can help providing You with lists and/or profile previews of HCPs who may be suitable to deliver the health care that You are seeking based on information that You provide to HealthyAlways (such as area of specialty and geographical location).</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.4. Please note that HealthyAlways (i) does not recommend or endorse any HCPs mentioned on the Website; and (ii) does not make any representations or warranties with respect to HCPs or the quality of the healthcare services they may provide, and (iii) does not grade physicians.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.5. You will obtain all relevant consents and approvals prior to posting or providing any User Content.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.6. You may schedule an appointment on the Website for Your family members and friends. However please note that such you will be solely responsible for any activity that is undertaken through his/her account on behalf of his/her family members and friends. </span>
			</p>
			<p class="c0">
				<span class="c1">2.2.7. You have the option of uploading your identifiable health information including physical, physiological and mental health condition, and medical records and history on the Website which may be accessed by the HCP at the time of private interactions using the Website. </span>
			</p>
			<p class="c0">
				<span class="c1">2.2.8. HealthyAlways will levy an advance internet handling fee for each private interaction that you have with an HCP through the Website. HealthyAlways will also collect the consultation fee payable to the HCP in advance on behalf of HCP and pay to HCP without retaining any share from fees.</span>
			</p>
			<p class="c0">
				<span class="c1">2.2.9. You may use the Website to order Lab Tests from Labs. The Website allows you to schedule a time for a home sample collection and pay the corresponding Lab Test fee. If you cancel a Lab Test order prior to the sample collection, you will receive a full refund of the Lab Test fee. If you cancel a Lab Test after the sample collection, you will receive a refund for the Lab Test fee, less the applicable collection service charge.</span>
			</p>
			<p class="c0">
				<span class="c1">2.3. Use by Non-Registered User</span>
			</p>
			<p class="c0">
				<span class="c1">2.3.1. HealthyAlways will provide you with lists and/or profile previews of HCPs based on information that you provide to the Website&#39;s search features (such as area of specialty and geographical location). Please note that HealthyAlways (i) does not recommend or endorse any HCPs mentioned on the Website; and (ii) does not make any representations or warranties with respect to these HCPs or the quality of the healthcare services they may provide</span>
			</p>
			<p class="c0">
				<span class="c1">2.4. Refund Policy for Paid Consults</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.1. In case a Healthcare Practitioner (HCP) is not available to respond to a paid consult, You can report the issue to HealthyAlways and request for cancellation, post which HealthyAlways will process the refund amount equalling to the total actual amount paid by You, including any internet handling fees. However, the refund will not include the discount value provided by HealthyAlways.</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.2. In the event it is proved that a HCP has acted in a manner that is against any applicable laws, HealthyAlways shall provide complete refund to you, subject to investigation undertaken by HealthyAlways.</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.3. In the event it is proved that you have demonstrated abusive nature during the consult, you shall not be eligible for any refund and HealthyAlways/HCP shall be entitled to take any legal action as applicable.</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.4. You are allowed a period of seven (7) days to report any consult as incomplete or unsatisfactory, and request for a refund. No refund requests shall be entertained thereafter.</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.5. You can request a refund from your consult chat screen or by sending us an email at care@HealthyAlways.com.</span>
			</p>
			<p class="c0">
				<span class="c1">2.4.6. In the event HealthyAlways establishes that your refund claim meets the above conditions, HealthyAlways shall process the refund accordingly and the money will be refunded to you in three (3) working days from the day refund has been approved from HealthyAlways.</span>
			</p>
			<p class="c0">
				<span class="c1">2.5. Refund Policy for Lab Tests</span>
			</p>
			<p class="c0">
				<span class="c1">2.5.1. If you cancel a Lab Test after the sample collection, refund will not be applicable. (Currently clause says partial refund will be provided)</span>
			</p>
			<p class="c0">
				<span class="c1">2.5.2. Refund due to any issues with processing of sample will be provided as per Lab&#39;s policy. HealthyAlways is not liable for any refund.</span>
			</p>
			<p class="c0">
				<span class="c1">2.5.3. Refund due to any issues with reporting will be provided as per Lab&#39;s policy. HealthyAlways is not liable.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6. HealthyAlways Points</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.1. HealthyAlways may in its discretion award HealthyAlways Points from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.2. HealthyAlways Points cannot be redeemed as cash. HealthyAlways points cannot be transferred to a wallet or to a bank account or to another HealthyAlways account.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.3. HealthyAlways Points can be applied on selected services or products available to HealthyAlways customers during checkout.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.4. HealthyAlways may in its discretion change the list of services on which HealthyAlways Points can be applied from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.5. HealthyAlways Points cannot be transferred from one account to another.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.6. Upon cancellation of services or purchase only the amount paid by user (after adjusting HealthyAlways points) will be refunded. HealthyAlways Points will not be refunded once they have been applied on a transaction.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.7. HealthyAlways may in its discretion add or remove the number of points associated with Your account from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.8. HealthyAlways may in its discretion modify applicability of points from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.9. HealthyAlways Points may be clubbed with extra discount for selected services or products.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.10. HealthyAlways may in its discretion modify list of services for which HealthyAlways Points can be clubbed with discounts from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.11. The amount of discount associated with application of HealthyAlways Points could vary from service to service.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6. Zasnova Healthcare. HealthyAlways may in its discretion modify the amount of discount associated with application of HealthyAlways Points for various services from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.13 HealthyAlways Points awarded to a particular user can be utilized for specific period of time, appearing at user&#39;s profile. Any unutilized HealthyAlways Points will automatically exhaust on expiry of period.</span>
			</p>
			<p class="c0">
				<span class="c1">2.6.14 HealthyAlways may in its discretion modify expiry period of HealthyAlways Points from time to time without any prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">3. ROLE OF HealthyAlways</span>
			</p>
			<p class="c0">
				<span class="c1">3.1. HealthyAlways role is limited to a) providing a platform for hosting and publishing User Content, Lab Content and HCP Content b) providing a platform for Registered Users to raise health related questions and HCP&#39;s to provide preliminary and generic information to the questions c) providing a platform for private interaction between Registered User and HCP d) providing a platform to find HCPs based on Registered User&#39;s inputs and HCP profiles created by HCPs themselves and e) providing a platform for Registered Users to order Lab Tests f) facilitating collection and disbursal of consultation and service fees for HCPs and Labs.</span>
			</p>
			<p class="c0">
				<span class="c1">3.2. HealthyAlways role is that of an &#39;intermediary&#39; as defined under the Information Technology Act, 2000 and the rules thereunder. Being an intermediary, HealthyAlways has no responsibility and / or liability in respect of the content and transactions on the Website including any User Content, Lab Content or HCP Content , information provided by HCPs or Labs, interactions between HCPs and Labs on the one hand and Users on the other hand.</span>
			</p>
			<p class="c0">
				<span class="c1">3.3. HealthyAlways does not have the obligation to pre-screen or monitor User Content, Lab Content or HCP Content at any time. However HealthyAlways may elect to monitor any User Content or HCP Content and remove any User Content and HCP Content from the Website if HealthyAlways determines in its sole discretion that such User Content and/or HCP Content is in violation of this Agreement or any applicable law and best practices. Where HealthyAlways removes any User Content or HCP Content from the Website, HealthyAlways will make reasonable efforts to inform the User or HCP who had posted such User Content or HCP Content respectively. Such actions do not in manner negate or dilute HealthyAlways position as an intermediary or impose any liability on HealthyAlways with respect to User Content and/or HCP Content.</span>
			</p>
			<p class="c0">
				<span class="c1">3.4. If HealthyAlways suspects any illegal, wrongful or fraudulent activity on the Website by any Registered User, Lab or HCP, notwithstanding any other rights HealthyAlways may have, HealthyAlways reserves the right to inform the relevant government or law enforcement authorities. HealthyAlways will cooperate in all investigative procedures or requests for access / information initiated by any such government or law enforcement authorities.</span>
			</p>
			<p class="c0">
				<span class="c1">3.5. HealthyAlways does not endorse or influence control over any particular branch of medicine, theory, opinion, viewpoint or position on any topic.</span>
			</p>
			<p class="c0">
				<span class="c1">4. LINKS TO THIRD PARTY WEBSITES</span>
			</p>
			<p class="c0">
				<span class="c1">4.1. You may be provided with links on the Website that direct you to third party websites / applications / content or service providers, including advertisers and e-commerce websites (collectively &quot;Third Party Websites&quot;).</span>
			</p>
			<p class="c0">
				<span class="c1">4.3. HealthyAlways does not endorse any Third Party Websites that you may be directed to from the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">4.2. Links to such Third Party Websites are provided for your convenience only. Please exercise your independent judgment and prudence when visiting / using any Third Party Websites via a link available on the Website. Should you decide to click on the links to visit such Third Party Website, You do so of your own volition. Your usage of such Third Party Websites and all content available on such Third Party Websites is subject to the terms of use of the respective Third Party Website and HealthyAlways is not responsible for your use of any Third Party Websites.</span>
			</p>
			<p class="c0">
				<span class="c1">5. PROPRIETARY RIGHTS</span>
			</p>
			<p class="c0">
				<span class="c1">5.1. HealthyAlways respects the intellectual property rights of others, and We expect the same from You. The Website, User Content, HCP Content, Lab Content and the HealthyAlways Content are protected by applicable intellectual property laws of United States.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2. HealthyAlways Rights to the Website and HealthyAlways Content</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.1. All intellectual property in and to the Website, any software, techniques and processes used in connection with the Website, belongs exclusively to HealthyAlways or its licensors. Through Your use of the Website, by no means are any rights impliedly or expressly granted by HealthyAlways to You in respect of such works.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.2. HealthyAlways and/or its licensors assert all proprietary rights in and to all names and trademarks contained on the Website. Notwithstanding the generality of the foregoing, the name, &quot;HealthyAlways&quot; is the trademark and copyright (or any other intellectual property right) of HealthyAlways and/or its licensors. Any use of the HealthyAlways trademarks or copyright, unless otherwise authorized in a written agreement, will constitute an infringement upon the trademark and copyright (or any other such intellectual property right) of HealthyAlways and may be actionable under the applicable laws.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.3. Except as stated otherwise in this Agreement all HealthyAlways Content (including all intellectual property rights to such content) is owned exclusively by HealthyAlways and/or its licensors.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.4. When you use the Website in accordance with this Agreement, a limited royalty-free right is granted to you by HealthyAlways to use HealthyAlways Content for personal and non-commercial use in India for the time that you are either a Registered User or an HCP or for the time that you make use of the Website, whichever is less.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.5. Unless explicitly stated herein, nothing in this Agreement shall be construed as conferring on You any license to intellectual property rights, whether by estoppel, implication, or otherwise.</span>
			</p>
			<p class="c0">
				<span class="c1">5.2.6. Unless expressly authorized by HealthyAlways, You agree not to reproduce, modify, sell, distribute, mirror, frame, republish, download, transmit, or create derivative works of the HealthyAlways Content, in whole or in part, by any means. You must not remove or modify any copyright or trademark notice, or other notice of ownership.</span>
			</p>
			<p class="c0">
				<span class="c1">5.3. Rights in User Content and HCP Content</span>
			</p>
			<p class="c0">
				<span class="c1">5.3.1. You agree that you are the owner of all rights (including all intellectual property rights) in the User Content (in case you are a Registered User) or HCP Content (in case you are a HCP) that you post on the Website or provide to HealthyAlways.</span>
			</p>
			<p class="c0">
				<span class="c1">5.3.2. You hereby grant HealthyAlways a perpetual, non-revocable, worldwide, royalty-free license to make use of such User Content (in case You are a Registered User) or HCP Content (in case You are a HCP) including the right to copy, distribute, display, reproduce, modify, adapt, the User Content or HCP Content, as the case may me, and create derivate works of the User Content or HCP Content, as the case may be.</span>
			</p>
			<p class="c0">
				<span class="c1">6. PERSONAL INFORMATION</span>
			</p>
			<p class="c0">
				<span class="c1">6.1.1. We may collect personal information from you when you use the Website and or the features provided by the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">6.1.2. Our Privacy Policy available at www.HealthyAlways.com/privacy sets out our policy with respect to the collection, storage, use, transfer and protection of any such personal information.</span>
			</p>
			<p class="c0">
				<span class="c1">6.1.3. When you click on the &#39;I accept&#39; or &#39;I agree&#39; tab at the time of registering or otherwise provide your personal information, you specifically consent to Our Privacy Policy.</span>
			</p>
			<p class="c0">
				<span class="c1">6.1.4. HealthyAlways may disclose Your Personal Information in accordance with applicable law.</span>
			</p>
			<p class="c0">
				<span class="c1">7. DISCLAIMERS</span>
			</p>
			<p class="c0">
				<span class="c1">7.1. Interaction with HCP on the Website:</span>
			</p>
			<p class="c0">
				<span class="c1">7.1.1. You understand and agree that any interactions and associated issues with the HCP(s) on the Website, is strictly between you and the HCP(s). You shall not hold HealthyAlways responsible for any such interactions and associated issues. HealthyAlways is not involved in the providing any healthcare or medical advice or diagnosis and hence is not responsible for any outcome between you and the HCP you interact with. If you decide to engage with a HCP to provide medical services to You, You do so at your own risk.</span>
			</p>
			<p class="c0">
				<span class="c1">7.1.2. The results of any search you perform on the Website for HCPs, or provision of access to any HCP on the basis of your specific request, should not be construed as endorsement by this Website of any such particular HCP. We make no guarantees, representations or warranties, whether expressed or implied, with respect to professional qualifications, quality of work, expertise of the HCP. The search results are based on an object computer algorithm.</span>
			</p>
			<p class="c0">
				<span class="c1">7.1.3. HealthyAlways shall not be responsible for any breach of service or service deficiency by any HCP.</span>
			</p>
			<p class="c0">
				<span class="c1">7.1.4. We can neither assure that all transactions on the Website will be completed nor do we guarantee the ability or intent of HCP to fulfil their obligations in any transaction. We advise you to perform your own investigation prior to selecting a HCP. </span>
			</p>
			<p class="c0">
				<span class="c1">7.2. Interaction with Labs on the Website:</span>
			</p>
			<p class="c0">
				<span class="c1">7.2.1. You understand and agree that any interactions and associated issues with the Lab(s) on the Website, is strictly between you and the Lab(s). You shall not hold HealthyAlways responsible for any such interactions and associated issues. HealthyAlways is not involved in the providing any healthcare or medical advice or diagnosis and hence is not responsible for any outcome between you and the Lab you interact with. If you decide to engage with a Lab to provide lab or diagnostic services to You, You do so at your own risk.</span>
			</p>
			<p class="c0">
				<span class="c1">7.2.2. We make no guarantees, representations or warranties, whether expressed or implied, with respect to professional qualifications, quality of work, or expertise of any Lab.</span>
			</p>
			<p class="c0">
				<span class="c1">7.2.3. HealthyAlways shall not be responsible for any breach of service or service deficiency by any Lab.</span>
			</p>
			<p class="c0">
				<span class="c1">7.2.4. We can neither assure that all transactions on the Website will be completed nor do we guarantee the ability or intent of a Lab to fulfil their obligations in any transaction. We advise you to perform your own investigation prior to ordering a Lab Test.</span>
			</p>
			<p class="c0">
				<span class="c1">7.3. Clinical Support Information: We may provide information to assist you in clinical decision-making. This may include information and reminders concerning drug interactions, lab and diagnostic services, allergies, dosages, as well as general health-care related information and resources. The information and materials available through the Website are for informational and educational purposes only and are not intended to constitute professional advice, diagnosis or treatment, or to substitute professional judgment. Information that may be placed on the Website by third parties, including HCP Content, and Lab Content, is beyond our control. We are not responsible for the accuracy or completeness of information available from or through Our Website. You assume full risk and responsibility for the use of information you obtain from or through this site, and you agree that HealthyAlways is not responsible or liable for any claim, loss, or liability arising from the use of the information. We do not recommend or endorse any HCP, Lab or diagnostic or health-related products, items or services, and the appearance of materials on the Website relating to any such products, items or services is not an endorsement or recommendation of them. You agree to review the definitions, functionality, and limitations of the information on the Website, and to make an independent determination of their suitability for Your use. We make no guarantees, representations or warranties, whether expressed or implied, with respect to information provided on the website</span>
			</p>
			<p class="c0">
				<span class="c1">7.4. Information regarding HCP/Lab and practice information: Information regarding HCP/Lab and practice information found on the Website is intended for general reference purposes only. Such information found on the Website is mainly self-reported by the HCP. Such information often changes frequently and may become out of date or inaccurate. Neither the Website nor HealthyAlways provides any advice or qualification certification about any particular HCP or Lab. You are encouraged to independently verify any such information you see on the Website with respect to a HCP or Lab that you seek to make an appointment with. </span>
			</p>
			<p class="c0">
				<span class="c1">7.5. No Professional Relationship: Please note that some of the content including text, data, graphics, images, information, suggestions, guidance, and other material that may be available on the Website (including information provided in direct response to Your questions or postings) may be provided by HCPs or Labs. The provision of such content to You by HealthyAlways does not constitute delivery of health care or diagnostic services to you and does not create a professional relationship between HealthyAlways and You. </span>
			</p>
			<p class="c0">
				<span class="c1">7.6. No Medical Advice Provided: The content provided by the Website, either by HealthyAlways or by HCP, should not be construed under any circumstances to be an opinion, medical advice, or diagnosis or treatment of any particular condition, but is only provided to assist you with locating appropriate medical care from a qualified practitioner. </span>
			</p>
			<p class="c0">
				<span class="c1">If you rely on any of the Information provided by the Website, You do so solely at your own risk. The Information that You obtain or receive from HealthyAlways, and its employees, contractors, partners, sponsors, advertisers, licensors or otherwise on the Website is for informational and scheduling purposes only. In no event shall we be liable to you or anyone else for any decision made or action taken by you in reliance on such information.</span>
			</p>
			<p class="c0">
				<span class="c1">7.7. Non-substitution of professional medical advice: The Information provided on the Website and in any other communications from or provided through HealthyAlways is not intended as a substitute for, nor does it replace, professional medical advice, diagnosis, or treatment. Do not disregard, avoid or delay obtaining medical advice from a qualified health care professional because of advice that you may have obtained through the Website. Your use of Information provided on the Website is solely at your own risk. Nothing stated or posted on the Website or available through any Services is intended to be, and must not be taken to be, the practice of medicine or the provision of medical care. You acknowledge and confirm that HealthyAlways shall not be responsible for Your treatment or be treated as a health care provider on account of collection of the consultation fees for private consultation by HCP or collection of fees for Lab Tests by Labs, for any reason whatsoever.</span>
			</p>
			<p class="c0">
				<span class="c1">7.8. HealthyAlways DISCLAIMS ANY REPRESENTATION AND/OR WARRANTYFOR THE SECURITY, RELIABILITY, QUALITY, TIMELINESS, AND PERFORMANCE OF (I) THE WEBSITE AND ITS FEATURES; (II) HCP WHO RESPONDS TO QUESTION OF A REGISTERED USER OR WHO INTERACTS PRIVATELY WITH A REGISTERED USER; (III) ANY INFORMATION, CONTENT OR ADVICE AVAILABLE ON OR RECEIVED THROUGH THE WEBSITE (IV) ACCESS TO OR ALTERATION OF USER CONTENT OR HCP CONTENT (V) TRANSMISSIONS OR DATA AND (VI) THE ACCURACY OF ANY LAB CONTENT INCLUDING LAB TEST RESULTS (VII)ANY OTHER MATTER RELATING TO THE WEBSITE AND / OR SERVICES.</span>
			</p>
			<p class="c0">
				<span class="c1">7.9. HealthyAlways MAKES NO WARRANTY OR REPRESENTATION THAT ANY ERRORS IN THE WEBSITE WILL BE CORRECTED EXCEPT AS REQUIRED BY LAW.</span>
			</p>
			<p class="c0">
				<span class="c1">7.10. HealthyAlways ASSUMES NO RESPONSIBILITY AND/OR LIABILITY WITH RESPECT TO ANY USER CONTENT, LAB CONTENT OR HCP CONTENT (AS APPLICABLE) WHICH YOU MAY POST ON THE WEBSITE AND YOU ARE SOLELY RESPONSIBLE FOR SUCH USER CONTENT POSTED ON THE SITE.</span>
			</p>
			<p class="c0">
				<span class="c1">7.11. YOU AGREE THAT THE OPEN AND REAL-TIME NATURE OF THE PLATFORM MAKE IT IMPOSSIBLE FOR HealthyAlways TO VOUCH FOR THE VALIDITY, AUTHETICITY AND HONESTY OF USER CONTENT OR HCP CONTENT. HEALTHYALWAYS IS NOT RESPONSIBLE FOR ANY USER CONTENT OR HCP CONTENT ON THE SITE, OR FOR THE CONSEQUENCES OF YOU READING OR RELYING ON SUCH CONTENT.</span>
			</p>
			<p class="c0">
				<span class="c1">7. ZASNOVA HEALTHCARE. THE SITE IS PROVIDED ON A &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS. NEITHER HEALTHYALWAYS NOR ANY THIRD PARTY SERVICE PROVIDERS ARE LIABLE FOR ANY TECHNICAL OR OTHER OPERATIONAL DIFFICULTIES OR PROBLEMS WHICH MAY RESULT IN LOSS OF YOUR DATA, PERSONALIZATION SETTINGS OR OTHER INTERRUPTIONS IN THE FEATURES OFFERED ON THE WEBSITE. NEITHER HEALTHYALWAYS NOR ANY THIRD PARTY IS LIABLE FOR THE DELETION, LOSS, MIS-DELIVERY, TIMELINESS OR FAILURE TO STORE OR TRANSMIT ANY USER CONTENT, LAB CONTENT OR HCP CONTENT, HEALTHYALWAYS CONTENT OR YOUR PERSONALIZATION SETTINGS.</span>
			</p>
			<p class="c0">
				<span class="c1">7.13. HEALTHYALWAYS DOES NOT PROVIDE ANY GUARANTEE AND SHALL NOT BE HELD LIABLE OR RESPONSIBLE FOR THE FAILURE TO SEND SMS OR OTHER NOTIFICATIONS OR REMINDERS TO YOU AS A FEATURE OF THE WEBSITE.</span>
			</p>
			<p class="c0">
				<span class="c1">7.14. Neither the HCP HealthyAlways shall be responsible nor liable for any breach or loss of data including Personal Information caused due to events beyond the control of HCPs / HealthyAlways or due to technical reasons or third party actions.</span>
			</p>
			<p class="c0">
				<span class="c1">8. LIMITATION OF LIABILITY:</span>
			</p>
			<p class="c0">
				<span class="c1">8.1. To the fullest extent permitted by law, in no event will HealthyAlways or its affiliates be liable for any direct, indirect, special, incidental, punitive, exemplary or consequential damages (including, without limitation, loss of business, revenue, profits, goodwill), whether or not HealthyAlways has been warned of the possibility of such damages or could have reasonably foreseen such damages. Notwithstanding anything to the contrary in this Agreement, HealthyAlways liability under this Agreement shall in no event exceed the fee amounts collected from you in the preceding one year or INR 5000 whichever is lower. </span>
			</p>
			<p class="c0">
				<span class="c1">9. REPRESENTATION AND WARRANTIES</span>
			</p>
			<p class="c0">
				<span class="c1">By Using This Website You Represent And Warrant That: </span>
			</p>
			<p class="c0">
				<span class="c1">9.1. You are 18 years of age or older and that your use of the Website shall not violate any applicable law or regulation;</span>
			</p>
			<p class="c0">
				<span class="c1">9.2. All registration information you submit is truthful and accurate and that you agree to maintain the accuracy of such information;</span>
			</p>
			<p class="c0">
				<span class="c1">9.3. You as a Registered or Non-Registered User will use the Website solely for your personal and non-commercial use. Any use of this Website or its content other than for personal purposes is prohibited.</span>
			</p>
			<p class="c0">
				<span class="c1">9.4. Your use of this Website shall be subjected to the following restrictions:</span>
			</p>
			<p class="c0">
				<span class="c1">9.4.1. You will not delete or modify any content of the Website including but not limited to, legal notices, disclaimers or proprietary notices such as copyright or trademark symbols, logos, that You do not own or have express permission to modify;</span>
			</p>
			<p class="c0">
				<span class="c1">9.4.2. You will not decompile, reverse engineer, or disassemble the content, or</span>
			</p>
			<p class="c0">
				<span class="c1">9.4.3. You will not remove any copyright, trademark registration, or other proprietary notices from the Website. You further agree not to access or use this Website in any manner that may be harmful to the operation of this Website or its content. </span>
			</p>
			<p class="c0">
				<span class="c1">9.5. You will not use the Website and / or services in any way that is unlawful, or harms the Company or any other person or entity, as determined in the Company&#39;s sole discretion.</span>
			</p>
			<p class="c0">
				<span class="c1">9.6. You will not engage in any form of antisocial, disrupting, or destructive acts, including &quot;flaming&quot;, &quot;spamming&quot;, &quot;flooding&quot;, &quot;trolling&quot;, &quot;phishing&quot; and &quot;griefing&quot; as those terms are commonly understood and used on the Internet.</span>
			</p>
			<p class="c0">
				<span class="c1">9.7. You will not host, display, upload, modify, publish, transmit, update or share any information that &mdash;</span>
			</p>
			<p class="c0">
				<span class="c1">(a) belongs to another person and to which the user does not have any right to;</span>
			</p>
			<p class="c0">
				<span class="c1">(b) is grossly harmful, harassing, blasphemous defamatory, obscene, pornographic, paedophilic, libellous, invasive of another&#39;s privacy, hateful, or racially, ethnically objectionable, disparaging, relating or encouraging money laundering or gambling, or otherwise unlawful in any manner whatever;</span>
			</p>
			<p class="c0">
				<span class="c1">(c) Harm minors in any way;</span>
			</p>
			<p class="c0">
				<span class="c1">(d) Infringes any patent, trademark, copyright or other proprietary rights(s), violates any law for the time being in force;</span>
			</p>
			<p class="c0">
				<span class="c1">(f) Deceives or misleads the addressee about the origin of such messages or communicates any information which is grossly offensive or menacing in nature;</span>
			</p>
			<p class="c0">
				<span class="c1">(g) Impersonate another person;</span>
			</p>
			<p class="c0">
				<span class="c1">(h) contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer resource;</span>
			</p>
			<p class="c0">
				<span class="c1">(i) Threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign states, or public order or causes incitement to the commission of any cognizable offence or prevents investigation of any offence or is insulting any other nation.</span>
			</p>
			<p class="c0">
				<span class="c1">10. INDEMNIFICATION</span>
			</p>
			<p class="c0">
				<span class="c1">You hereby indemnify, defend, and hold HealthyAlways, the HealthyAlways distributors, agents, representatives and other authorized users (Registered and Non-Registered Users, HCPs), and each of the foregoing entities&#39; respective resellers, distributors, service providers and suppliers, and all of the foregoing entities&#39; respective officers, directors, owners, employees, agents, representatives, harmless from and against any and all losses, damages, liabilities and costs arising from (i)Your use of the Website (ii) Your breach of provisions of this Agreement and (iii) any negligent or intentional wrongdoing on Your part. </span>
			</p>
			<p class="c0">
				<span class="c1">11. TERMINATION </span>
			</p>
			<p class="c0">
				<span class="c1">HealthyAlways reserves the right, in the event it finds out in its sole discretion that You breached the Agreement, to suspend and / or terminate Your user account and/or access to the Website by blocking Your IP address or email id with or without notice to You. Any suspected illegal, fraudulent or abusive activity may be grounds for suspending and / or terminating your user account and/or your access to the Website. Upon suspension or termination, your right to use the features on the Website shall immediately cease and the Company reserves the right to remove or delete your information that is available with the Company, including but not limited to login and account information. </span>
			</p>
			<p class="c0">
				<span class="c1">Upon user account termination or suspension, regardless of the reasons therefore, Your right to use the Website, User Content, HCP Content or HealthyAlways Content immediately ceases, and You acknowledge and agree that We may immediately deactivate or delete Your account and all related information and files in Your account and/or bar any further access to such files or this site. HealthyAlways shall not be liable to you or any third party for any claims or damages arising out of any termination or suspension of your user account or any other actions taken by us in connection with such account termination or suspension.</span>
			</p>
			<p class="c0">
				<span class="c1">ZASNOVA HEALTHCARE GOVERNING LAW AND JURISDICTION</span>
			</p>
			<p class="c0">
				<span class="c1">The interpretation of this Agreement and the resolution of any disputes arising under this Agreement shall be governed by the laws of India. </span>
			</p>
			<p class="c0">
				<span class="c1">13. MODIFICATIONS</span>
			</p>
			<p class="c0">
				<span class="c1">13.1. HealthyAlways reserves the right to modify any part of the Agreement at any time without giving you prior notice.</span>
			</p>
			<p class="c0">
				<span class="c1">13.2. When We update the Agreement, the next time You visit the Website, the Website will provide a message to You (which may be sent by email if You have provided Your Email Id) which will intimate You of the amendments. You do not agree to the amendments; please do not use the Website any further.</span>
			</p>
			<p class="c0">
				<span class="c1">14. ARBITRATION </span>
			</p>
			<p class="c0">
				<span class="c1">14.1. Any dispute, claim or controversy arising out of or relating to this notice or the breach, termination, enforcement, interpretation or validity thereof, including the determination of the scope or applicability of this Agreement to arbitrate, or to Your use of the Website or its features or the information to which it gives access, shall be determined by arbitration in India, before a single arbitrator in accordance with the India Arbitration Rules.</span>
			</p>
			<p class="c0">
				<span class="c1">14.2. The Parties shall have the right to apply to a court of competent jurisdiction to obtain interim injunctive relief in respect of any dispute, pending resolution of such dispute in accordance with the Agreement.</span>
			</p>
			<p class="c0">
				<span class="c1">15. GENERAL PROVISIONS</span>
			</p>
			<p class="c0">
				<span class="c1">15.1. Severability: If any provision of this Agreement is held by a court of competent jurisdiction or arbitral tribunal to be unenforceable under applicable law, then such provision shall be excluded from the Agreement and the remainder of the Agreement shall be interpreted as if such provision were so excluded and shall be enforceable in accordance with its terms; provided however that, in such event the Agreement shall be interpreted so as to give effect, to the greatest extent consistent with and permitted by applicable law, to the meaning and intention of the excluded provision as determined by such court of competent jurisdiction or arbitral tribunal. </span>
			</p>
			<p class="c0">
				<span class="c1">15.2. Notices: All notices and other communications required or permitted hereunder to be given to a Party shall be in writing, in the English language, and shall be sent by facsimile, e-mail, or mailed by prepaid internationally-recognized courier, or otherwise delivered by hand or by messenger, addressed to such Party&#39;s address as set forth below or at such other address as the Party shall have furnished to the other Party in writing in accordance with this provision:</span>
			</p>
			<p class="c0">
				<span class="c1">If to HealthyAlways: Zasnova Healthcare Private Limited</span>
			</p>
			<p class="c0">
				<span class="c1">If to You: at the email address provided by you to us when you registered as a HealthyAlways User.</span>
			</p>
			<p class="c0">
				<span class="c1">15.3. Waiver: No term of the Agreement shall be deemed waived and no breach excused, unless such waiver or consent shall be in writing and signed by the Party claimed to have waived or consented. Any consent by any Party to, or waiver of a breach by the other, whether expressed or implied, shall not constitute consent to, waiver of, or excuse for any other different or subsequent breach. </span>
			</p>
			<p class="c0">
				<span class="c1">15.4. Complete Understanding: The Agreement contains the entire understanding of the Parties, and there are no other written or oral understandings or promises between the Parties with respect to the subject matter of the Agreement other than those contained or referenced in the Agreement. </span>
			</p>
			<p class="c0">
				<span class="c1">15.5. Force Majeure: HealthyAlways shall not be liable for any downtime or delay or unavailability of the Website caused by circumstances beyond HealthyAlways &nbsp;reasonable control, including without limitation, acts of God, acts of government, floods, fires, earthquakes, civil unrest, acts of terror, strikes or other labour problems, internet service provider failures or delays, or denial of service attacks.</span>
			</p>
			<p class="c0">
				<span class="c1">15.6. Advice of Counsel: Each Party acknowledges: (a) having fully read the Agreement in its entirety; (b) had full opportunity to study and review the Agreement.</span>
			</p>
			<p class="c0">
				<span class="c1">15.7. Advertisement: HealthyAlways shall have the right to place advertisements and publicity materials of its choice, including that pertaining to parties other than itself for commercial use through electronic means on the Website. &nbsp;</span>
			</p>
			<p class="c0">
				<span class="c1">15.8. Assignment: You may not assign or sub-license, without the prior written consent of HealthyAlways, the rights, duties or obligations under this Agreement, in whole or in part, to any person or entity.</span>
			</p>
			<p class="c0">
				<span class="c1">15.9. Conflict: In the event there is any conflict between the terms set out in these Terms of Use, the Privacy Policy, the Additional Terms of Use for HCPs and any other policies applicable to specific pages of the Website, the following order of prevalence shall apply: (i) the Privacy Policy (ii) these Terms of Use, (iii) the Additional Terms of Use for HCPs and (iv) any other policies applicable to specific pages of the Website.</span>
			</p>
			<p class="c0">
				<span class="c1">16. RETURN &amp; REFUND POLICY</span>
			</p>
			<p class="c0">
				<span class="c1">16.1. At HealthyAlways.com, we do our best to ensure that our customers are immensely satisfied with our products. And we are happy to offer a complete refund in the following circumstances.</span>
			</p>
			<p class="c0">
				<span class="c1">(a) You received a defective/damaged item(s).</span>
			</p>
			<p class="c0">
				<span class="c1">(b) Delivered item(s) doesn&#39;t match your order.</span>
			</p>
			<p class="c0">
				<span class="c1">(c) The ordered item(s) is/are lost or damaged during transit.</span>
			</p>
			<p class="c0">
				<span class="c1">16.2. Following circumstances do not qualify for Return or Refund.</span>
			</p>
			<p class="c0">
				<span class="c1">(a) Any wrong ordering of product doesn&rsquo;t qualify for Return or refund.</span>
			</p>
			<p class="c0">
				<span class="c1">(b) Return or refund requests arising due to change in prescription do not qualify for Return.</span>
			</p>
			<p class="c0">
				<span class="c1">(c) All products to be returned should always be in their original manufacturer&#39;s packaging i.e. with original tags, labels, bar-code and invoice.</span>
			</p>
			<p class="c0">
				<span class="c1">(d) Used, Opened or Partially consumed products do not qualify for return; only completely intact products can be returned.</span>
			</p>
			<p class="c0">
				<span class="c1">(e) Return product should have the same batch number as mentioned on the invoice.</span>
			</p>
			<p class="c0">
				<span class="c1">(f) Non delivery of product reported after 48 hours of delivery confirmation text message on registered mobile number.</span>
			</p>
			<p class="c0">
				<span class="c1">16.3. How to Request a Refund:</span>
			</p>
			<p class="c0">
				<span class="c1">To request a refund, simply email us your order details, including the reason why you&rsquo;re requesting a refund at care@HealthyAlways.com.</span>
			</p>
			<p class="c0">
				<span class="c1">16.4. Please Note: Mode of refund may vary from case to case. If the mode of refund is by Credit/Debit Card or Net Banking, allow 7 to 14 working days for the credit to appear in your account. If the mode of refund is by Wallet, credit should be available within 7 to 10 working days.</span>
			</p>
			<p class="c0">
				<span class="c1">17. LEGAL DISCLAIMER</span>
			</p>
			<p class="c0" id="h.gjdgxs">
				<span class="c1">17.1 While we ensure that all product information on the platform is complete and accurate, however, we advise you not to solely rely on this information. It is recommended to refer to the product manual and/or specifications provided by the manufacturer either on their website or along with the product.</span>
			</p>
			<p class="c0">
				<span class="c1">17.2 This is applicable for all warnings, labels, ingredients and usage directions as well.</span>
			</p>
			<p class="c0">
				<span class="c1">17.3 The use of any information provided on this platform is solely at the user&#39;s risk. Nothing contained on this platform shall be considered as medical advice.</span>
			</p>
			<p class="c0">
				<span class="c1">17.4 Consumers are advised to contact the manufacturer for any further information and assistance.</span>
			</p>
			<p class="c0 c3">
				<span class="c4"></span>
			</p>
			<p class="c0">
				<span class="c1">&nbsp;</span>
			</p>
			<p class="c0 c3">
				<span class="c1"></span>
			</p>
		</body>
	</html>
            </v-row>
        </v-container>
    
</template>

<script>
    export default {
        name: "TermsAndConditions",         
        methods: {}
           
    }
</script>

<style scoped type="text/css">@import url('https://themes.googleusercontent.com/fonts/css?kit=fpjTOVmNbO4Lz34iLyptLUXza5VhXqVC6o75Eld_V98');
ol {
	margin: 0;
	padding: 0
}

table td,
table th {
	padding: 0
}

.c4 {
	color: #000000;
	font-weight: 700;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 14pt;
	font-family: "Calibri";
	font-style: normal
}

.c1 {
	color: #000000;
	font-weight: 400;
	text-decoration: none;
	vertical-align: baseline;
	font-size: 11pt;
	font-family: "Calibri";
	font-style: normal
}

.c0 {
	padding-top: 0pt;
	padding-bottom: 10pt;
	line-height: 1.1500000000000001;
	orphans: 2;
	widows: 2;
	text-align: left
}

.c2 {
	background-color: #ffffff;	
	
}

.c3 {
	height: 11pt
}

.title {
	padding-top: 24pt;
	color: #000000;
	font-weight: 700;
	font-size: 36pt;
	padding-bottom: 6pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

.subtitle {
	padding-top: 18pt;
	color: #666666;
	font-size: 24pt;
	padding-bottom: 4pt;
	font-family: "Georgia";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	font-style: italic;
	orphans: 2;
	widows: 2;
	text-align: left
}

li {
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

p {
	margin: 0;
	color: #000000;
	font-size: 11pt;
	font-family: "Calibri"
}

h1 {
	padding-top: 24pt;
	color: #000000;
	font-weight: 700;
	font-size: 24pt;
	padding-bottom: 6pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h2 {
	padding-top: 18pt;
	color: #000000;
	font-weight: 700;
	font-size: 18pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h3 {
	padding-top: 14pt;
	color: #000000;
	font-weight: 700;
	font-size: 14pt;
	padding-bottom: 4pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h4 {
	padding-top: 12pt;
	color: #000000;
	font-weight: 700;
	font-size: 12pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h5 {
	padding-top: 11pt;
	color: #000000;
	font-weight: 700;
	font-size: 11pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}

h6 {
	padding-top: 10pt;
	color: #000000;
	font-weight: 700;
	font-size: 10pt;
	padding-bottom: 2pt;
	font-family: "Calibri";
	line-height: 1.1500000000000001;
	page-break-after: avoid;
	orphans: 2;
	widows: 2;
	text-align: left
}


html{
    overflow-y:auto;
}

</style>